// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"90d5f0b8","16":"eeb12225","148":"200177ed","497":"25f9bb57","504":"a2ee6e31","521":"2501d8e9","929":"0d8d5453"}[chunkId] + ".chunk.css";
};